import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import Header from "../../../components/molecules/Header";
import { CircularProgress, Container, Typography } from "@material-ui/core";
import {
  useData,
  productsCollection,
} from "../../../components/firebase/DataProvider";
import { FieldValue } from "../../../components/firebase/FirebaseProvider";
import useStyles from "./style/style";
import Produk from "./produk";
import HeaderToko from "./headerToko";
// import SpeedDial from "@material-ui/lab/SpeedDial";
import SpeedDialIcon from "@material-ui/lab/SpeedDialIcon";
// import SpeedDialAction from "@material-ui/lab/SpeedDialAction";
// import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import InfiniteScroll from "react-infinite-scroll-component";

import { Button } from "@material-ui/core";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import { useSnackbar } from "notistack";
// import SkeletonProduct from "../../../components/atoms/SkeletonProduct";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const actions = [
  { icon: <SpeedDialIcon />, name: "Tambah", operation: "tambah" },
  { icon: <DeleteIcon />, name: `Hapus\bSemua\bProduk`, operation: "hapus" },
];

function TokoSaya() {
  const { webstore, webstoreRef, level } = useData();

  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [productIds, setProductIds] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(true);
  const lastProduct = useRef(6);
  const allProducts = useRef(false);
  const [productIDsEffect, setProductIDsEffect] = useState(true);

  const classes = useStyles();

  // console.log("productid", productIds);
  // console.log("product", products);

  const [openDialog, setOpenDialog] = useState(false);

  const handleShow = () => setOpenDialog(!openDialog);

  const removeAllProduct = async () => {
    //remove
    setLoading(true);
    setOpenDialog(false);
    try {
      await webstoreRef.set(
        { products: [], products_discount: FieldValue.delete() },
        { merge: true }
      );
      setProducts([]);
      setProductIds([]);
      setLoading(false);
      enqueueSnackbar("Semua produk berhasil di hapus!", {
        variant: "success",
      });
    } catch (e) {
      console.log(e.message);
    }
  };

  const removeProduct = (index) => async (productId) => {
    //remove
    // console.log("ini hapus");
    try {
      await webstoreRef.set(
        { products: FieldValue.arrayRemove(productId) },
        { merge: true }
      );

      setProducts((oldProducts) => {
        const start = oldProducts.slice(0, index);
        const rest = oldProducts.slice(index + 1);

        return start.concat(rest);
      });

      enqueueSnackbar("Produk berhasil di hapus!", {
        variant: "success",
      });
    } catch (e) {
      console.log(e.message);
    }
  };

  const handleClick = (e, operation) => {
    e.preventDefault();
    if (operation === "Tambah") {
      history.push("/tokosaya/pilih");
    } else {
      setOpenDialog(true);
    }
  };

  // const init = useCallback(async () => {
  //   const checkWebstore = await webstoreRef.get();
  //   if (checkWebstore.exists) {
  //     return;
  //   } else {
  //     navigation.navigate("UpdateToko");
  //   }
  // }, []);

  const loadMoreProducts = async function () {
    // console.log("ini jalan");
    if (lastProduct.current && loadingMore) {
      setLoadingMore(true);
      try {
        const start = lastProduct.current - 6;
        const end = lastProduct.current;
        if (!allProducts.current) {
          if (end >= productIds?.length) {
            allProducts.current = true;
          } else {
            lastProduct.current += 6;
          }

          const query = productIds.slice(start, end);

          const newProducts = await Promise.all(
            query.map(async (productId) => {
              const doc = await productsCollection.doc(productId).get();

              if (doc.exists) {
                const variants = await productsCollection
                  .doc(productId)
                  .collection("variants")
                  .where(`harga_normal`, ">", 0)
                  .get();

                return {
                  id: productId,
                  variants: variants.docs.map((variant) => {
                    return {
                      id: variant.id,
                      ...variant.data(),
                    };
                  }),
                  ...doc.data(),
                };
              }
              return null;
            })
          );

          const filteredProducts = newProducts.filter(
            (product) =>
              product.variants?.length > 0 && !product?.sembunyikan_produk
          );
          setProducts((products) => [...products, ...filteredProducts]);
          lastProduct.current = query.docs[query.docs?.length - 1];
        } else {
          setLoadingMore(false);
        }
      } catch (e) {
        console.log(e.message);
        // setLoadingMore(false);
      }
    }
  };

  useEffect(() => {
    if (productIds?.length && productIDsEffect) {
      setProductIDsEffect(false);
      setLoading(true);
      lastProduct.current = 6;
      allProducts.current = false;
      setProducts([]);

      const loadProducts = async function () {
        try {
          const start = lastProduct.current - 6;
          const end = lastProduct.current;
          if (!allProducts.current) {
            if (end >= productIds?.length) {
              allProducts.current = true;
            } else {
              lastProduct.current += 6;
            }

            const query = productIds.slice(start, end);
            const newProducts = await Promise.all(
              query.map(async (productId) => {
                const doc = await productsCollection.doc(productId).get();

                if (doc.exists) {
                  const variants = await productsCollection
                    .doc(productId)
                    .collection("variants")
                    .where(`harga_normal`, ">", 0)
                    .get();

                  return {
                    id: productId,
                    variants: variants.docs.map((variant) => {
                      return {
                        id: variant.id,
                        ...variant.data(),
                      };
                    }),
                    ...doc.data(),
                  };
                }
                return null;
              })
            );

            const filteredProducts = newProducts.filter(
              (product) =>
                product.variants?.length > 0 && !product?.sembunyikan_produk
            );
            setProducts((products) => [...products, ...filteredProducts]);
            lastProduct.current = query.docs[query.docs?.length - 1];
          } else {
            setLoading(false);
          }
        } catch (e) {
          console.log(e.message);
          setLoading(false);
        }
      };

      loadProducts();
    }
  }, [lastProduct, allProducts, productIds, productIDsEffect]);

  useEffect(() => {
    if (webstore?.products) {
      if (webstore?.products?.length) {
        setProductIds([...webstore?.products].reverse());
      } else {
        setLoading(false);
      }
    }
  }, [webstore?.products]);

  // useEffect(() => {
  //   init();
  // }, [init]);
  // console.log(products);
  return (
    <>
      <Header type="for-tokosaya" title="Toko saya" />
      <HeaderToko
        {...level}
        {...webstore}
        webstoreRef={webstoreRef}
        openDialog={handleShow}
      />
      <Container>
        <InfiniteScroll
          dataLength={products?.length}
          style={{
            overflow: "hidden",
            marginBottom: "60px",
            marginTop: "-50px",
          }}
          next={loadMoreProducts}
          hasMore={loadingMore}
          scrollThreshold
          loader={
            products.length <= 0 ? null : (
              <Typography
                color="primary"
                style={{ textAlign: "center", marginBottom: "20px" }}
              >
                <b>Memuat</b>
              </Typography>
            )
          }
          endMessage={
            <p style={{ textAlign: "center" }}>
              {products?.length <= 0 ? null : (
                <b>Yay! Kamu Sudah Melihat Semua</b>
              )}
            </p>
          }
        >
          <div>
            {loading ? (
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  // height: "100vh",
                  flex: 1,
                  justifyContent: "center",
                  alignItems: "center",
                  // backgroundColor: 'black',
                  opacity: 0.4,
                  // position: "fixed",
                  zIndex: 9999,
                  // left: 0,
                  // marginBottom: "2.5%",
                  marginTop: "100px",
                  // right: 0,
                  // bottom: 0,
                  // top: 0,
                }}
              >
                <CircularProgress />
              </div>
            ) : (
              <Produk product={products} remove={removeProduct} />
            )}
          </div>
        </InfiniteScroll>
        {/* <SpeedDial
          ariaLabel="SpeedDial tooltip example"
          className={classes.fab1}
          hidden={hidden}
          icon={<EditIcon />}
          onClose={handleClose}
          onOpen={handleOpen}
          open={open}
          direction="up"
        >
          {actions.map((action) => (
            <SpeedDialAction
              key={action.name}
              icon={action.icon}
              tooltipTitle={action.name}
              tooltipOpen
              onClick={(e) => {
                handleClick(e, action.name);
              }}
            />
          ))}
        </SpeedDial> */}
      </Container>
      <Dialog
        open={openDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleShow}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">{"Konfirmasi"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {products?.length <= 0
              ? "Maaf anda tidak memiliki produk di Toko Saya"
              : "Yakin ingin menghapus semua produk yang berada di Toko Saya."}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleShow} color="primary">
            Batalkan
          </Button>
          <Button
            onClick={products?.length <= 0 ? handleShow : removeAllProduct}
            color="primary"
            disable={loading}
          >
            Iya
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default TokoSaya;
